import React from "react";
import {Link} from "react-router-dom";

const AllOptionsPage = () => {
    return(
        <div className="userWelcome">
            <h1 className="userWelcomeTypingTitle">Feature Under Develoment</h1>
        </div>
    );
};

export default AllOptionsPage;